import React from 'react';
import { useStatPermissionsQuery } from '@famly/stat_permissions_data';
import { unrestrictedCRUD, defaultPermissions } from './default-permissions';
import { crudPermissionAdapter } from './crud-permission-adapter';
export function useStatPermissions(payload) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const queries = useStatPermissionsQuery({
        variables: {
            siteSetId: payload.institutionSetId,
            childId: payload.childId,
            employeeId: payload.employeeId,
            formId: payload.formId,
            ratioCalculationConfig: payload.ratioCalculationConfig,
        },
    });
    const baseData = queries.base.data;
    const employeeData = (_a = queries.employee) === null || _a === void 0 ? void 0 : _a.data;
    const childData = (_b = queries.child) === null || _b === void 0 ? void 0 : _b.data;
    const formData = (_c = queries.form) === null || _c === void 0 ? void 0 : _c.data;
    const ratioInfoData = queries.ratioInfo.data;
    const loadingPermissionData = queries.base.loading ||
        ((_e = (_d = queries.employee) === null || _d === void 0 ? void 0 : _d.loading) !== null && _e !== void 0 ? _e : false) ||
        ((_g = (_f = queries.child) === null || _f === void 0 ? void 0 : _f.loading) !== null && _g !== void 0 ? _g : false) ||
        ((_j = (_h = queries.form) === null || _h === void 0 ? void 0 : _h.loading) !== null && _j !== void 0 ? _j : false) ||
        queries.ratioInfo.loading;
    const refetch = React.useCallback(async (query) => {
        var _a, _b, _c, _d, _e, _f;
        switch (query) {
            case 'base':
                await queries.base.refetch();
                break;
            case 'employee':
                await ((_a = queries.employee) === null || _a === void 0 ? void 0 : _a.refetch());
                break;
            case 'child':
                await ((_b = queries.child) === null || _b === void 0 ? void 0 : _b.refetch());
                break;
            case 'form':
                await ((_c = queries.form) === null || _c === void 0 ? void 0 : _c.refetch());
                break;
            case 'ratioInfo':
                await queries.ratioInfo.refetch();
                break;
            default:
                await Promise.all([
                    queries.base.refetch(),
                    (_d = queries.employee) === null || _d === void 0 ? void 0 : _d.refetch(),
                    (_e = queries.child) === null || _e === void 0 ? void 0 : _e.refetch(),
                    (_f = queries.form) === null || _f === void 0 ? void 0 : _f.refetch(),
                    queries.ratioInfo.refetch(),
                ]);
        }
    }, [queries]);
    const permissions = React.useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119;
        if (loadingPermissionData) {
            return defaultPermissions;
        }
        const isOrganizationView = window.location.hash.includes('organization');
        const subtypes = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.subtypes;
        const subtypesV2 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.subtype;
        const shiftPlanner = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.shiftplanner;
        const shiftPlannerPublished = (_b = (_a = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.shiftplanner) === null || _a === void 0 ? void 0 : _a.shift) === null || _b === void 0 ? void 0 : _b.published;
        const schedules = employeeData === null || employeeData === void 0 ? void 0 : employeeData.staffhours.management.schedules;
        const staffAttendance = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.staffAttendance.siteSet;
        const staffHours = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.totals;
        const staffAttendanceByEmployee = employeeData === null || employeeData === void 0 ? void 0 : employeeData.staffhours.management.staffAttendance.employee;
        const contractedHours = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.contractedHours;
        const customFte = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.customFte;
        const enrollment = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.customRegistrationForm.enrollment;
        const interest = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.customRegistrationForm.interest;
        const registration = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.customRegistrationForm.registration;
        const manageForm = formData === null || formData === void 0 ? void 0 : formData.attendance.management.customRegistrationForm.byFormId;
        const manageFormBySiteSetId = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.customRegistrationForm.bySiteSetId;
        const employees = baseData === null || baseData === void 0 ? void 0 : baseData.management.employees;
        const ageGroupsManagement = baseData === null || baseData === void 0 ? void 0 : baseData.management.ageGroups;
        const careGroupsManagement = baseData === null || baseData === void 0 ? void 0 : baseData.management.careGroups;
        const careRulesManagement = baseData === null || baseData === void 0 ? void 0 : baseData.management.careRules;
        const careSummaryManagement = baseData === null || baseData === void 0 ? void 0 : baseData.management.careSummary;
        const additionalNeedTypesManagement = baseData === null || baseData === void 0 ? void 0 : baseData.additionalNeedTypes.management;
        const additionalNeedsAssignmentPermissions = childData === null || childData === void 0 ? void 0 : childData.childProfile.additionalNeeds.permissions;
        const attendanceFeatures = (_c = baseData === null || baseData === void 0 ? void 0 : baseData.attendance) === null || _c === void 0 ? void 0 : _c.featureSettings;
        const staffHoursFeatures = (_d = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours) === null || _d === void 0 ? void 0 : _d.featureSettings;
        const contractTemplateManagementFlags = (_e = baseData === null || baseData === void 0 ? void 0 : baseData.careContractTemplates) === null || _e === void 0 ? void 0 : _e.managementFlags;
        const careContractManagementFlags = (_g = (_f = baseData === null || baseData === void 0 ? void 0 : baseData.childProfile) === null || _f === void 0 ? void 0 : _f.careContracts) === null || _g === void 0 ? void 0 : _g.managementFlags;
        return {
            unrestricted: unrestrictedCRUD,
            exactAttendance: {
                canRead: (_h = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.featureSettings.exactAttendance.isEnabled) !== null && _h !== void 0 ? _h : false,
                canUpdate: false,
                canCreate: false,
                canDelete: false,
            },
            subtypes: crudPermissionAdapter(subtypes),
            subtypesV2: {
                ...crudPermissionAdapter(subtypesV2),
            },
            fte: crudPermissionAdapter(customFte),
            shiftPlanner: {
                general: crudPermissionAdapter(shiftPlanner),
                shift: {
                    draft: crudPermissionAdapter(shiftPlanner === null || shiftPlanner === void 0 ? void 0 : shiftPlanner.shift.draft),
                    published: crudPermissionAdapter(shiftPlannerPublished),
                },
            },
            schedules: crudPermissionAdapter(schedules),
            staffAttendance: crudPermissionAdapter(staffAttendance),
            staffHours: { ...crudPermissionAdapter(staffHours), canUpdate: Boolean(staffHours === null || staffHours === void 0 ? void 0 : staffHours.canView) },
            staffAttendanceByEmployee: crudPermissionAdapter(staffAttendanceByEmployee),
            customRegistrationForms: {
                enrollment: crudPermissionAdapter(enrollment),
                interest: crudPermissionAdapter(interest),
                registration: crudPermissionAdapter(registration),
                manageForm: {
                    ...crudPermissionAdapter(manageForm),
                    canCreateFollowUpForm: (_j = manageForm === null || manageForm === void 0 ? void 0 : manageForm.canCreateFollowUpForm) !== null && _j !== void 0 ? _j : false,
                    name: {
                        canCreate: false,
                        canRead: true,
                        canUpdate: Boolean(manageForm === null || manageForm === void 0 ? void 0 : manageForm.canEditName),
                        canDelete: false,
                    },
                    publish: {
                        canCreate: false,
                        canRead: true,
                        canUpdate: Boolean(manageForm === null || manageForm === void 0 ? void 0 : manageForm.canPublish),
                        canDelete: false,
                    },
                    unpublish: {
                        canCreate: false,
                        canRead: true,
                        canUpdate: Boolean(manageForm === null || manageForm === void 0 ? void 0 : manageForm.canUnpublish),
                        canDelete: false,
                    },
                    responses: {
                        canCreate: false,
                        canRead: Boolean(manageForm === null || manageForm === void 0 ? void 0 : manageForm.canDownloadResponses),
                        canUpdate: false,
                        canDelete: false,
                    },
                    successMessage: {
                        canCreate: false,
                        canRead: true,
                        canUpdate: Boolean(manageForm === null || manageForm === void 0 ? void 0 : manageForm.canEditSuccessMessage),
                        canDelete: false,
                    },
                    toggleNotifications: {
                        canCreate: false,
                        canRead: true,
                        canUpdate: Boolean(manageForm === null || manageForm === void 0 ? void 0 : manageForm.canToggleNotifications),
                        canDelete: false,
                    },
                    // The backend folds the confirmation-email site feature into this permission, so
                    // a site without the feature reads as no access rather than read-only access.
                    confirmationEmail: {
                        canCreate: false,
                        canRead: Boolean(manageForm === null || manageForm === void 0 ? void 0 : manageForm.canToggleConfirmationEmail),
                        canUpdate: Boolean(manageForm === null || manageForm === void 0 ? void 0 : manageForm.canToggleConfirmationEmail),
                        canDelete: false,
                    },
                    share: {
                        canCreate: false,
                        canRead: false,
                        canUpdate: Boolean(manageForm === null || manageForm === void 0 ? void 0 : manageForm.canShare),
                        canDelete: false,
                    },
                    duplicate: {
                        canCreate: Boolean(manageForm === null || manageForm === void 0 ? void 0 : manageForm.canDuplicate),
                        canRead: false,
                        canUpdate: false,
                        canDelete: false,
                    },
                    manageSubmissionKeys: {
                        canCreate: Boolean(manageForm === null || manageForm === void 0 ? void 0 : manageForm.canManageSubmissionKeys),
                        canRead: false,
                        canUpdate: false,
                        canDelete: false,
                    },
                    sendEmails: {
                        canCreate: Boolean(manageForm === null || manageForm === void 0 ? void 0 : manageForm.canSendEmails),
                        canRead: false,
                        canUpdate: false,
                        canDelete: false,
                    },
                    viewResponses: {
                        canRead: Boolean(manageForm === null || manageForm === void 0 ? void 0 : manageForm.canViewResponses),
                        canCreate: false,
                        canUpdate: false,
                        canDelete: false,
                    },
                    feeAmount: {
                        canCreate: false,
                        canRead: Boolean(manageForm === null || manageForm === void 0 ? void 0 : manageForm.canViewFeeSection),
                        canUpdate: Boolean(manageForm === null || manageForm === void 0 ? void 0 : manageForm.canSetFeeAmount),
                        canDelete: false,
                    },
                },
                manageFormBySiteSetId: {
                    ...crudPermissionAdapter(manageFormBySiteSetId),
                    canCreateFollowUpForm: (_k = manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canCreateFollowUpForm) !== null && _k !== void 0 ? _k : false,
                    name: {
                        canCreate: false,
                        canRead: true,
                        canUpdate: Boolean(manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canEditName),
                        canDelete: false,
                    },
                    publish: {
                        canCreate: false,
                        canRead: true,
                        canUpdate: Boolean(manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canPublish),
                        canDelete: false,
                    },
                    unpublish: {
                        canCreate: false,
                        canRead: true,
                        canUpdate: Boolean(manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canUnpublish),
                        canDelete: false,
                    },
                    responses: {
                        canCreate: false,
                        canRead: Boolean(manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canDownloadResponses),
                        canUpdate: false,
                        canDelete: false,
                    },
                    successMessage: {
                        canCreate: false,
                        canRead: true,
                        canUpdate: Boolean(manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canEditSuccessMessage),
                        canDelete: false,
                    },
                    toggleNotifications: {
                        canCreate: false,
                        canRead: true,
                        canUpdate: Boolean(manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canToggleNotifications),
                        canDelete: false,
                    },
                    // The backend folds the confirmation-email site feature into this permission, so
                    // a site without the feature reads as no access rather than read-only access.
                    confirmationEmail: {
                        canCreate: false,
                        canRead: Boolean(manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canToggleConfirmationEmail),
                        canUpdate: Boolean(manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canToggleConfirmationEmail),
                        canDelete: false,
                    },
                    share: {
                        canCreate: false,
                        canRead: false,
                        canUpdate: Boolean(manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canShare),
                        canDelete: false,
                    },
                    duplicate: {
                        canCreate: Boolean(manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canDuplicate),
                        canRead: false,
                        canUpdate: false,
                        canDelete: false,
                    },
                    manageSubmissionKeys: {
                        canCreate: Boolean(manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canManageSubmissionKeys),
                        canRead: false,
                        canUpdate: false,
                        canDelete: false,
                    },
                    sendEmails: {
                        canCreate: Boolean(manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canSendEmails),
                        canRead: false,
                        canUpdate: false,
                        canDelete: false,
                    },
                    viewResponses: {
                        canRead: Boolean(manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canViewResponses),
                        canCreate: false,
                        canUpdate: false,
                        canDelete: false,
                    },
                    feeAmount: {
                        canCreate: false,
                        canRead: Boolean(manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canViewFeeSection),
                        canUpdate: Boolean(manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canSetFeeAmount),
                        canDelete: false,
                    },
                },
                ofChild: {
                    responses: {
                        canRead: (_m = (_l = childData === null || childData === void 0 ? void 0 : childData.attendance.management.customRegistrationForm.forChild) === null || _l === void 0 ? void 0 : _l.canViewSubmissions) !== null && _m !== void 0 ? _m : false,
                        canCreate: false,
                        canDelete: false,
                        canUpdate: false,
                    },
                    status: {
                        canRead: (_p = (_o = childData === null || childData === void 0 ? void 0 : childData.attendance.management.customRegistrationForm.forChild) === null || _o === void 0 ? void 0 : _o.canViewStatuses) !== null && _p !== void 0 ? _p : false,
                        canCreate: false,
                        canDelete: false,
                        canUpdate: false,
                    },
                },
            },
            institution: {
                employees: { ...crudPermissionAdapter(employees), canManageRolesAndPermissions: false },
            },
            attendance: {
                header: {
                    export: {
                        dailyTotals: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.attendance.dailyCsvExportURL),
                        detailedBreakdown: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.attendance.detailedCsvExportURL),
                    },
                },
                content: {},
            },
            attendanceDetails: {
                header: {
                    staffSelector: {
                        ...crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.attendance.siteSet),
                        // The staff selector will either be shown or not. It doesn't make any sense to have a disabled staff selector.
                        // Given the staff selector allows us to VIEW (and not edit) other's data,
                        // it makes sense to link the canUpdate to the canRead flag from BE.
                        canUpdate: (_q = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.attendance.siteSet.canView) !== null && _q !== void 0 ? _q : false,
                    },
                    goToSchedule: crudPermissionAdapter(shiftPlanner),
                },
                content: {
                    cell: {
                        schedule: crudPermissionAdapter(shiftPlannerPublished),
                        attendance: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.attendance),
                        breaks: crudPermissionAdapter(shiftPlannerPublished),
                    },
                    actions: {
                        addAttendance: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.attendance.siteSet),
                        addPersonalAttendance: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.attendance),
                    },
                    totals: {
                        schedule: crudPermissionAdapter(shiftPlannerPublished),
                        contracted: crudPermissionAdapter(contractedHours === null || contractedHours === void 0 ? void 0 : contractedHours.contractedHours),
                        bankHours: crudPermissionAdapter(contractedHours === null || contractedHours === void 0 ? void 0 : contractedHours.bankHours),
                        attended: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.attendance),
                        breaks: crudPermissionAdapter(shiftPlannerPublished),
                    },
                },
            },
            childAttendance: {
                header: {
                    export: {
                        milkReport: {
                            canCreate: false,
                            canRead: (_s = (_r = attendanceFeatures === null || attendanceFeatures === void 0 ? void 0 : attendanceFeatures.milkReport) === null || _r === void 0 ? void 0 : _r.enabled) !== null && _s !== void 0 ? _s : false,
                            canUpdate: false,
                            canDelete: false,
                        },
                        kinderConnect: {
                            canCreate: (_u = (_t = attendanceFeatures === null || attendanceFeatures === void 0 ? void 0 : attendanceFeatures.kinderConnect) === null || _t === void 0 ? void 0 : _t.enabled) !== null && _u !== void 0 ? _u : false,
                            canRead: (_w = (_v = attendanceFeatures === null || attendanceFeatures === void 0 ? void 0 : attendanceFeatures.kinderConnect) === null || _v === void 0 ? void 0 : _v.enabled) !== null && _w !== void 0 ? _w : false,
                            canUpdate: false,
                            canDelete: false,
                        },
                        exportCsv: {
                            canRead: Boolean((_y = (_x = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.childAttendance.flags) === null || _x === void 0 ? void 0 : _x.at(0)) === null || _y === void 0 ? void 0 : _y.canExportCsv),
                            canCreate: false,
                            canUpdate: false,
                            canDelete: false,
                        },
                    },
                },
                content: {},
            },
            forms: {
                header: {
                    newForm: {
                        canCreate: false,
                        canRead: 
                        // We currently don't allow creating a form in organization context, so false is returned here.
                        (_z = (!isOrganizationView &&
                            // If the user can create at least one form type, the new-form toolbar is shown.
                            // Follow-up (and All about me) forms only require "manage forms", not "Create children",
                            // so canCreateFollowUpForm is included here separately from the create-children-gated types.
                            ((enrollment === null || enrollment === void 0 ? void 0 : enrollment.canCreate) ||
                                (interest === null || interest === void 0 ? void 0 : interest.canCreate) ||
                                (registration === null || registration === void 0 ? void 0 : registration.canCreate) ||
                                (manageFormBySiteSetId === null || manageFormBySiteSetId === void 0 ? void 0 : manageFormBySiteSetId.canCreateFollowUpForm)))) !== null && _z !== void 0 ? _z : false,
                        canUpdate: false,
                        canDelete: false,
                    },
                },
                content: {},
            },
            inquiries: {
                header: {
                    downloadCsv: {
                        canRead: !(attendanceFeatures === null || attendanceFeatures === void 0 ? void 0 : attendanceFeatures.inquiry.hideEnquiryCSVDownload),
                        canUpdate: (_0 = attendanceFeatures === null || attendanceFeatures === void 0 ? void 0 : attendanceFeatures.inquiry.hideEnquiryCSVDownload) !== null && _0 !== void 0 ? _0 : true,
                        canCreate: false,
                        canDelete: false,
                    },
                    newInquiry: {
                        canCreate: (_2 = (!(attendanceFeatures === null || attendanceFeatures === void 0 ? void 0 : attendanceFeatures.inquiry.hideNewEnquiryButton) &&
                            ((_1 = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.orgInquiries[0]) === null || _1 === void 0 ? void 0 : _1.canCreate))) !== null && _2 !== void 0 ? _2 : false,
                        canRead: (_4 = (!(attendanceFeatures === null || attendanceFeatures === void 0 ? void 0 : attendanceFeatures.inquiry.hideNewEnquiryButton) &&
                            ((_3 = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.orgInquiries[0]) === null || _3 === void 0 ? void 0 : _3.canCreate))) !== null && _4 !== void 0 ? _4 : false,
                        canUpdate: false,
                        canDelete: false,
                    },
                },
                content: {
                    enrollChild: {
                        canCreate: (_6 = (_5 = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.orgInquiries[0]) === null || _5 === void 0 ? void 0 : _5.canEnrollChildren) !== null && _6 !== void 0 ? _6 : false,
                        canRead: (_8 = (_7 = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.orgInquiries[0]) === null || _7 === void 0 ? void 0 : _7.canEnrollChildren) !== null && _8 !== void 0 ? _8 : false,
                        canUpdate: false,
                        canDelete: false,
                    },
                    // Holding a place is part of managing the site's enquiries, which `canUpdate` carries
                    holdPlace: {
                        canCreate: false,
                        canRead: (_10 = (_9 = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.orgInquiries[0]) === null || _9 === void 0 ? void 0 : _9.canUpdate) !== null && _10 !== void 0 ? _10 : false,
                        canUpdate: (_12 = (_11 = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.orgInquiries[0]) === null || _11 === void 0 ? void 0 : _11.canUpdate) !== null && _12 !== void 0 ? _12 : false,
                        canDelete: false,
                    },
                    // Releasing needs the same right as holding
                    releasePlace: {
                        canCreate: false,
                        canRead: (_14 = (_13 = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.orgInquiries[0]) === null || _13 === void 0 ? void 0 : _13.canUpdate) !== null && _14 !== void 0 ? _14 : false,
                        canUpdate: (_16 = (_15 = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.orgInquiries[0]) === null || _15 === void 0 ? void 0 : _15.canUpdate) !== null && _16 !== void 0 ? _16 : false,
                        canDelete: false,
                    },
                },
            },
            occupancyBudgets: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.occupancyBudgets),
            staffHoursPage: {
                header: {
                    seeChangeLog: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.contractedHours.changeLog),
                    export: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.totals.csvExport),
                    filters: {
                        ...crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.totals),
                        canUpdate: (_17 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.totals.canView) !== null && _17 !== void 0 ? _17 : false,
                    },
                },
                content: {
                    bankHours: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.contractedHours.bankHours),
                    approveAndLockHours: {
                        canRead: (_19 = (_18 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours) === null || _18 === void 0 ? void 0 : _18.management.approval.canApproveAndLockAll) !== null && _19 !== void 0 ? _19 : false,
                        canUpdate: (_21 = (_20 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours) === null || _20 === void 0 ? void 0 : _20.management.approval.canApproveAndLockAll) !== null && _21 !== void 0 ? _21 : false,
                        // Not used in this scenario, so we set it to false.
                        canCreate: false,
                        canDelete: false,
                    },
                    unlockHours: {
                        canRead: (_22 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.approval.canUnlockAll) !== null && _22 !== void 0 ? _22 : false,
                        canUpdate: (_23 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.approval.canUnlockAll) !== null && _23 !== void 0 ? _23 : false,
                        // Not used in this scenario, so we set it to false.
                        canCreate: false,
                        canDelete: false,
                    },
                    approvalView: {
                        canRead: (_24 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.approval.canViewAll) !== null && _24 !== void 0 ? _24 : false,
                        // Not used in this scenario, so we set it to false.
                        canUpdate: false,
                        canCreate: false,
                        canDelete: false,
                    },
                },
            },
            staffHoursSettingsPage: {
                header: {
                    exactAttendanceOptIn: {
                        canRead: (_25 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.featureSettings.exactAttendance.canOptIn) !== null && _25 !== void 0 ? _25 : false,
                        canUpdate: (_26 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.featureSettings.exactAttendance.canOptIn) !== null && _26 !== void 0 ? _26 : false,
                        canCreate: false,
                        canDelete: false,
                    },
                },
                content: {},
            },
            onboardingTeamContacts: {
                canRead: (_27 = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.onboardingTeamContacts.canView) !== null && _27 !== void 0 ? _27 : false,
                canUpdate: (_28 = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.onboardingTeamContacts.canUpdate) !== null && _28 !== void 0 ? _28 : false,
                canCreate: false,
                canDelete: false,
            },
            staffLeaveSettingsV2: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.staffLeaveSettings),
            staffLeaveV2: {
                // Mapping both canRead and canUpdate permissions to the "isEnabled" flag received from BE
                canRead: (_29 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.featureSettings.staffLeave.isEnabled) !== null && _29 !== void 0 ? _29 : false,
                canUpdate: (_30 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.featureSettings.staffLeave.isEnabled) !== null && _30 !== void 0 ? _30 : false,
                canCreate: false,
                canDelete: false,
            },
            staffLeaveV2Conflicts: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.conflicts),
            staffLeaveV2Page: {
                completed: crudPermissionAdapter((_31 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave) === null || _31 === void 0 ? void 0 : _31.completed),
                pending: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.pending),
                totals: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.totals),
                csvExportOverview: {
                    canRead: (_32 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.csvExportOverview.canView) !== null && _32 !== void 0 ? _32 : false,
                    canCreate: (_33 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.csvExportOverview.canView) !== null && _33 !== void 0 ? _33 : false,
                    canDelete: false,
                    canUpdate: false,
                },
                csvExportTotals: {
                    totals: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.csvExportTotals),
                    details: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.csvExportDetailed),
                },
                changeLog: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.contractedHours.changeLog),
                bradfordFactor: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.bradfordFactor),
                siteSet: {
                    completed: crudPermissionAdapter((_34 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave) === null || _34 === void 0 ? void 0 : _34.completed),
                    pending: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.pending),
                    totals: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.totals),
                },
                approveLeave: {
                    // Not relevant, defaulting to false
                    canCreate: false,
                    canRead: (_36 = (_35 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.pending) === null || _35 === void 0 ? void 0 : _35.canApprove) !== null && _36 !== void 0 ? _36 : false,
                    canUpdate: (_38 = (_37 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.pending) === null || _37 === void 0 ? void 0 : _37.canApprove) !== null && _38 !== void 0 ? _38 : false,
                    // Not relevant, defaulting to false
                    canDelete: false,
                },
                rejectLeave: {
                    // Not relevant, defaulting to false
                    canCreate: false,
                    canRead: (_40 = (_39 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.pending) === null || _39 === void 0 ? void 0 : _39.canReject) !== null && _40 !== void 0 ? _40 : false,
                    canUpdate: (_42 = (_41 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.pending) === null || _41 === void 0 ? void 0 : _41.canReject) !== null && _42 !== void 0 ? _42 : false,
                    // Not relevant, defaulting to false
                    canDelete: false,
                },
                pendingTab: {
                    canRead: (_44 = (_43 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.leave.pending) === null || _43 === void 0 ? void 0 : _43.canViewPendingTab) !== null && _44 !== void 0 ? _44 : false,
                    // THese are irrelevant, so can be safely set to false
                    canCreate: false,
                    canUpdate: false,
                    canDelete: false,
                },
            },
            staffOverview: {
                header: {},
                content: {
                    cells: {
                        employee: {
                            bankHours: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.contractedHours.bankHours),
                            contractedHours: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.contractedHours.contractedHours),
                        },
                        day: {
                            scheduled: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.shiftplanner),
                        },
                        total: {
                            scheduled: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.shiftplanner),
                        },
                    },
                },
            },
            staffOverviewPage: {
                header: {
                    addEmployee: {
                        canRead: (_45 = baseData === null || baseData === void 0 ? void 0 : baseData.management.employees.canCreate) !== null && _45 !== void 0 ? _45 : false,
                        canCreate: (_46 = baseData === null || baseData === void 0 ? void 0 : baseData.management.employees.canCreate) !== null && _46 !== void 0 ? _46 : false,
                        // Not used in this scenario, so we set it to false.
                        canUpdate: false,
                        canDelete: false,
                    },
                    manageRolesAndPermissions: {
                        canRead: (_47 = baseData === null || baseData === void 0 ? void 0 : baseData.management.employees.canManageRolesAndPermissions) !== null && _47 !== void 0 ? _47 : false,
                        canUpdate: (_48 = baseData === null || baseData === void 0 ? void 0 : baseData.management.employees.canManageRolesAndPermissions) !== null && _48 !== void 0 ? _48 : false,
                        // Not used in this scenario, so we set it to false.
                        canCreate: false,
                        canDelete: false,
                    },
                },
                content: {
                    canAssignRoles: {
                        canRead: (_49 = baseData === null || baseData === void 0 ? void 0 : baseData.management.employees.canAssignRoles) !== null && _49 !== void 0 ? _49 : false,
                        canUpdate: (_50 = baseData === null || baseData === void 0 ? void 0 : baseData.management.employees.canAssignRoles) !== null && _50 !== void 0 ? _50 : false,
                        // Not used in this scenario, so we set it to false.
                        canCreate: false,
                        canDelete: false,
                    },
                },
            },
            staffPlanner: {
                header: {
                    copyShifts: {
                        canCreate: false,
                        canRead: (_52 = (_51 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.shiftplanner) === null || _51 === void 0 ? void 0 : _51.canEdit) !== null && _52 !== void 0 ? _52 : false,
                        canUpdate: (_54 = (_53 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.shiftplanner) === null || _53 === void 0 ? void 0 : _53.canEdit) !== null && _54 !== void 0 ? _54 : false,
                        canDelete: false,
                    },
                    newShift: {
                        // When creating new shifts, they are always "DRAFT", so we need to check for the `draft.canCreate` permission
                        canCreate: (_56 = (_55 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.shiftplanner) === null || _55 === void 0 ? void 0 : _55.shift.draft.canCreate) !== null && _56 !== void 0 ? _56 : false,
                        canRead: (_58 = (_57 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.shiftplanner) === null || _57 === void 0 ? void 0 : _57.shift.draft.canCreate) !== null && _58 !== void 0 ? _58 : false,
                        canUpdate: false,
                        canDelete: false,
                    },
                    deleteShift: {
                        canCreate: false,
                        canRead: (_60 = (_59 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.shiftplanner) === null || _59 === void 0 ? void 0 : _59.shift.draft.canDelete) !== null && _60 !== void 0 ? _60 : false,
                        canUpdate: false,
                        canDelete: (_62 = (_61 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.shiftplanner) === null || _61 === void 0 ? void 0 : _61.shift.draft.canDelete) !== null && _62 !== void 0 ? _62 : false,
                    },
                    bulkDeleteShift: {
                        canCreate: false,
                        canRead: (_64 = (((_63 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.shiftplanner) === null || _63 === void 0 ? void 0 : _63.shift.draft.canBulkDelete) ||
                            (shiftPlannerPublished === null || shiftPlannerPublished === void 0 ? void 0 : shiftPlannerPublished.canBulkDelete))) !== null && _64 !== void 0 ? _64 : false,
                        canUpdate: false,
                        canDelete: (_66 = (((_65 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.shiftplanner) === null || _65 === void 0 ? void 0 : _65.shift.draft.canBulkDelete) ||
                            (shiftPlannerPublished === null || shiftPlannerPublished === void 0 ? void 0 : shiftPlannerPublished.canBulkDelete))) !== null && _66 !== void 0 ? _66 : false,
                    },
                },
                content: {
                    workAvailability: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.contractedHours.workAvailability),
                    contractedHours: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.contractedHours.contractedHours),
                    scheduledHours: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.shiftplanner),
                },
            },
            staffProfile: {
                scheduleWidget: {
                    ...crudPermissionAdapter(employeeData === null || employeeData === void 0 ? void 0 : employeeData.staffhours.management.schedules),
                    weeklyDetailsButton: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.attendance),
                    staffHoursButton: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.totals),
                    staffRotasButton: { canCreate: false, canDelete: false, canRead: false, canUpdate: false },
                },
                contract: {
                    page: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.management.employees.contractData),
                    weeklyHours: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.contractedHours.contractedHours),
                    workAvailability: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.contractedHours.workAvailability),
                    bankHours: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.contractedHours.bankHours),
                    changeLog: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.contractedHours.changeLog),
                },
                qualificationTypeAssignment: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.qualificationTypeAssignment),
                credentialAssignment: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.credentialsAssignment),
            },
            staffRatioReport: {
                header: {},
                content: {
                    scheduledStaff: {
                        ...crudPermissionAdapter(shiftPlannerPublished),
                        // In this scenario, the button's performs a "view" action (and not an "edit"/"update" action),
                        // so we map the "canUpdate" to the "canRead" permission accordingly.
                        canUpdate: (_67 = shiftPlannerPublished === null || shiftPlannerPublished === void 0 ? void 0 : shiftPlannerPublished.canView) !== null && _67 !== void 0 ? _67 : false,
                    },
                },
            },
            staffSchedule: {
                header: {
                    export: {
                        staffingCSV: {
                            canCreate: false,
                            canRead: (_68 = staffHoursFeatures === null || staffHoursFeatures === void 0 ? void 0 : staffHoursFeatures.shiftplanner.isEnabled) !== null && _68 !== void 0 ? _68 : false,
                            canUpdate: (_69 = staffHoursFeatures === null || staffHoursFeatures === void 0 ? void 0 : staffHoursFeatures.shiftplanner.isEnabled) !== null && _69 !== void 0 ? _69 : false,
                            canDelete: false,
                        },
                    },
                },
                content: {},
            },
            staffScheduleSettings: {
                editStaffSchedule: {
                    // We can read/update staff schedules only when the "shiftPlanner" feature is not enabled
                    canRead: !(staffHoursFeatures === null || staffHoursFeatures === void 0 ? void 0 : staffHoursFeatures.shiftplanner.isEnabled),
                    canUpdate: !(staffHoursFeatures === null || staffHoursFeatures === void 0 ? void 0 : staffHoursFeatures.shiftplanner.isEnabled),
                    canCreate: false,
                    canDelete: false,
                },
            },
            taskManagement: {
                base: {
                    ...crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.taskManagement.taskList),
                    // needs to be set manually as the backend naming convention ("canEdit" for update) was broken
                    canUpdate: (_71 = (_70 = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.taskManagement.taskList) === null || _70 === void 0 ? void 0 : _70.canUpdate) !== null && _71 !== void 0 ? _71 : false,
                },
                canTogglePublishedState: {
                    canRead: (_72 = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.taskManagement.taskList.canTogglePublishedState) !== null && _72 !== void 0 ? _72 : false,
                    canUpdate: (_73 = baseData === null || baseData === void 0 ? void 0 : baseData.attendance.management.taskManagement.taskList.canTogglePublishedState) !== null && _73 !== void 0 ? _73 : false,
                    canCreate: false,
                    canDelete: false,
                },
            },
            workTags: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.workTags),
            resourceLibraryPage: {
                header: {
                    addResource: {
                        canDelete: false,
                        canUpdate: false,
                        canRead: (_74 = baseData === null || baseData === void 0 ? void 0 : baseData.childDevelopment.resources.managementFlags.canEdit) !== null && _74 !== void 0 ? _74 : false,
                        canCreate: (_75 = baseData === null || baseData === void 0 ? void 0 : baseData.childDevelopment.resources.managementFlags.canEdit) !== null && _75 !== void 0 ? _75 : false,
                    },
                },
                content: {
                    editResource: {
                        canDelete: false,
                        canCreate: false,
                        canRead: (_76 = baseData === null || baseData === void 0 ? void 0 : baseData.childDevelopment.resources.managementFlags.canEdit) !== null && _76 !== void 0 ? _76 : false,
                        canUpdate: (_77 = baseData === null || baseData === void 0 ? void 0 : baseData.childDevelopment.resources.managementFlags.canEdit) !== null && _77 !== void 0 ? _77 : false,
                    },
                },
            },
            qualificationsSettings: {
                header: {},
                content: {
                    credentials: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.credentials),
                    qualificationTypes: crudPermissionAdapter(baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.management.qualificationType),
                },
            },
            contractTemplateManagementFlags: {
                canRead: (_78 = contractTemplateManagementFlags === null || contractTemplateManagementFlags === void 0 ? void 0 : contractTemplateManagementFlags.canManage) !== null && _78 !== void 0 ? _78 : false,
                canCreate: (_79 = contractTemplateManagementFlags === null || contractTemplateManagementFlags === void 0 ? void 0 : contractTemplateManagementFlags.canManage) !== null && _79 !== void 0 ? _79 : false,
                canDelete: (_80 = contractTemplateManagementFlags === null || contractTemplateManagementFlags === void 0 ? void 0 : contractTemplateManagementFlags.canManage) !== null && _80 !== void 0 ? _80 : false,
                canUpdate: (_81 = contractTemplateManagementFlags === null || contractTemplateManagementFlags === void 0 ? void 0 : contractTemplateManagementFlags.canManage) !== null && _81 !== void 0 ? _81 : false,
            },
            careContractManagementFlags: {
                canRead: (_82 = careContractManagementFlags === null || careContractManagementFlags === void 0 ? void 0 : careContractManagementFlags.canView) !== null && _82 !== void 0 ? _82 : false,
                canCreate: (_83 = careContractManagementFlags === null || careContractManagementFlags === void 0 ? void 0 : careContractManagementFlags.canCreate) !== null && _83 !== void 0 ? _83 : false,
                canDelete: (_84 = careContractManagementFlags === null || careContractManagementFlags === void 0 ? void 0 : careContractManagementFlags.canDelete) !== null && _84 !== void 0 ? _84 : false,
                canUpdate: false, // No update permission
                canViewFileUrls: (_85 = careContractManagementFlags === null || careContractManagementFlags === void 0 ? void 0 : careContractManagementFlags.canViewFileUrls) !== null && _85 !== void 0 ? _85 : false,
                canCreateFromTemplate: (_86 = careContractManagementFlags === null || careContractManagementFlags === void 0 ? void 0 : careContractManagementFlags.canCreateFromTemplate) !== null && _86 !== void 0 ? _86 : false,
            },
            ageGroups: {
                canRead: (_87 = ageGroupsManagement === null || ageGroupsManagement === void 0 ? void 0 : ageGroupsManagement.canView) !== null && _87 !== void 0 ? _87 : false,
                canEdit: (_88 = ageGroupsManagement === null || ageGroupsManagement === void 0 ? void 0 : ageGroupsManagement.canEdit) !== null && _88 !== void 0 ? _88 : false,
                canEditCapacityFactor: (_89 = ageGroupsManagement === null || ageGroupsManagement === void 0 ? void 0 : ageGroupsManagement.settings.canEditCapacityFactor) !== null && _89 !== void 0 ? _89 : false,
                settings: {
                    canRead: (_90 = ageGroupsManagement === null || ageGroupsManagement === void 0 ? void 0 : ageGroupsManagement.settings.canView) !== null && _90 !== void 0 ? _90 : false,
                    canEdit: (_91 = ageGroupsManagement === null || ageGroupsManagement === void 0 ? void 0 : ageGroupsManagement.settings.canEdit) !== null && _91 !== void 0 ? _91 : false,
                    canEditCapacityFactor: (_92 = ageGroupsManagement === null || ageGroupsManagement === void 0 ? void 0 : ageGroupsManagement.settings.canEditCapacityFactor) !== null && _92 !== void 0 ? _92 : false,
                },
            },
            careGroups: {
                canRead: (_93 = careGroupsManagement === null || careGroupsManagement === void 0 ? void 0 : careGroupsManagement.canView) !== null && _93 !== void 0 ? _93 : false,
                canEdit: (_94 = careGroupsManagement === null || careGroupsManagement === void 0 ? void 0 : careGroupsManagement.canEdit) !== null && _94 !== void 0 ? _94 : false,
                settings: {
                    canRead: (_95 = careGroupsManagement === null || careGroupsManagement === void 0 ? void 0 : careGroupsManagement.settings.canView) !== null && _95 !== void 0 ? _95 : false,
                    canEdit: (_96 = careGroupsManagement === null || careGroupsManagement === void 0 ? void 0 : careGroupsManagement.settings.canEdit) !== null && _96 !== void 0 ? _96 : false,
                },
            },
            careRules: {
                canRead: (_97 = careRulesManagement === null || careRulesManagement === void 0 ? void 0 : careRulesManagement.canView) !== null && _97 !== void 0 ? _97 : false,
                canEdit: (_98 = careRulesManagement === null || careRulesManagement === void 0 ? void 0 : careRulesManagement.canEdit) !== null && _98 !== void 0 ? _98 : false,
            },
            childAdditionalNeedTypes: {
                canView: (_99 = additionalNeedTypesManagement === null || additionalNeedTypesManagement === void 0 ? void 0 : additionalNeedTypesManagement.canView) !== null && _99 !== void 0 ? _99 : false,
                canEdit: (_100 = additionalNeedTypesManagement === null || additionalNeedTypesManagement === void 0 ? void 0 : additionalNeedTypesManagement.canEdit) !== null && _100 !== void 0 ? _100 : false,
            },
            childAdditionalNeedsAssignment: {
                canView: (_101 = additionalNeedsAssignmentPermissions === null || additionalNeedsAssignmentPermissions === void 0 ? void 0 : additionalNeedsAssignmentPermissions.canView) !== null && _101 !== void 0 ? _101 : false,
                canEdit: (_102 = additionalNeedsAssignmentPermissions === null || additionalNeedsAssignmentPermissions === void 0 ? void 0 : additionalNeedsAssignmentPermissions.canEdit) !== null && _102 !== void 0 ? _102 : false,
            },
            childAdditionalNeedsOverview: {
                canView: (_104 = (_103 = baseData === null || baseData === void 0 ? void 0 : baseData.additionalNeedTypes.childOverview) === null || _103 === void 0 ? void 0 : _103.canView) !== null && _104 !== void 0 ? _104 : false,
            },
            childAdditionalNeedsList: {
                canView: (_106 = (_105 = baseData === null || baseData === void 0 ? void 0 : baseData.additionalNeedTypes.childListPermissions) === null || _105 === void 0 ? void 0 : _105.canView) !== null && _106 !== void 0 ? _106 : false,
            },
            careSummary: {
                canViewGraph: (_107 = careSummaryManagement === null || careSummaryManagement === void 0 ? void 0 : careSummaryManagement.canViewGraph) !== null && _107 !== void 0 ? _107 : false,
                // the backend flag is named for a wider scope than it gates: the CSV has its own flag
                canViewIssues: (_108 = careSummaryManagement === null || careSummaryManagement === void 0 ? void 0 : careSummaryManagement.canViewIssuesAndCsv) !== null && _108 !== void 0 ? _108 : false,
                canViewCsv: (_109 = careSummaryManagement === null || careSummaryManagement === void 0 ? void 0 : careSummaryManagement.canViewCsv) !== null && _109 !== void 0 ? _109 : false,
            },
            ratioInfo: {
                canViewChildrenAttending: (_110 = ratioInfoData === null || ratioInfoData === void 0 ? void 0 : ratioInfoData.staffhours.management.ratioInfo.canViewChildrenAttending) !== null && _110 !== void 0 ? _110 : false,
                canViewStaffAttending: (_111 = ratioInfoData === null || ratioInfoData === void 0 ? void 0 : ratioInfoData.staffhours.management.ratioInfo.canViewStaffAttending) !== null && _111 !== void 0 ? _111 : false,
                canViewChildrenExpected: (_112 = ratioInfoData === null || ratioInfoData === void 0 ? void 0 : ratioInfoData.staffhours.management.ratioInfo.canViewChildrenExpected) !== null && _112 !== void 0 ? _112 : false,
                canViewStaffExpected: (_113 = ratioInfoData === null || ratioInfoData === void 0 ? void 0 : ratioInfoData.staffhours.management.ratioInfo.canViewStaffExpected) !== null && _113 !== void 0 ? _113 : false,
                canViewRatioInfo: (_114 = ratioInfoData === null || ratioInfoData === void 0 ? void 0 : ratioInfoData.staffhours.management.ratioInfo.canViewRatioInfo) !== null && _114 !== void 0 ? _114 : false,
                canViewCareRulesSummary: (_115 = ratioInfoData === null || ratioInfoData === void 0 ? void 0 : ratioInfoData.staffhours.management.ratioInfo.canViewCareRulesSummary) !== null && _115 !== void 0 ? _115 : false,
            },
            childBookingsNotice: {
                canRead: (_117 = (_116 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.shiftPlannerOnboarding) === null || _116 === void 0 ? void 0 : _116.recommendsChildPlansSetup) !== null && _117 !== void 0 ? _117 : false,
            },
            workTagColorsCoachMark: {
                canRead: (_119 = (_118 = baseData === null || baseData === void 0 ? void 0 : baseData.staffhours.shiftPlannerOnboarding) === null || _118 === void 0 ? void 0 : _118.recommendsNewWorkTagColors) !== null && _119 !== void 0 ? _119 : false,
            },
        };
    }, [loadingPermissionData, baseData, employeeData, childData, formData, ratioInfoData]);
    return React.useMemo(() => ({
        permissions,
        loading: loadingPermissionData,
        refetch,
    }), [loadingPermissionData, permissions, refetch]);
}
